/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// eslint-disable-next-line object-curly-newline
import {
  Grid,
  Container,
  Typography,
  TextField,
  Box,
  Button,
  Paper,
} from '@material-ui/core';
import axios from 'axios';
import logo from '../../assets/qmenu_logo.png';
import updateState from '../../actions/updateState';
import translate from '../../actions/translate';
import updateAnalytics from '../../actions/updateAnalytics';
import DesignAndLanguages from '../../components/DesignAndLanguages';
import LogoAndStepper from '../../components/LogoAndStepper';
import TopLayer from '../../components/layers/TopLayer';
import MiddleLayer from '../../components/layers/MiddleLayer';
import BottomLayer from '../../components/layers/BottomLayer';
import ViewPortContainer from '../../components/layers/ViewPortContainer';
import TransitionButtons from '../../components/TransitionButtons';
import BoxContentContainer from '../../components/layers/BoxContentContainer';

export default function SeamlessForm() {
  // media query, on greater than iphone
  const dispatch = useDispatch();
  const language = useSelector((state) => state.formState.Page_language);
  const baseURL = useSelector((state) => state.formState.baseURL);
  const [promo, setPromo] = useState(
    new URLSearchParams(window.location.search).get('code')
  );
  const env = process.env.REACT_APP_ENV;
  useEffect(() => {
    if (promo && promo.length) {
      dispatch(updateState({ Signup_type: 'promo' }));
      dispatch(updateState({ promocode: promo }));
      dispatch(updateState({ everCameFromPromo: true }));
    } else {
      dispatch(updateState({ step: 1 }));
      dispatch(updateState({ Signup_type: 'Non_promo' }));
      dispatch(updateState({ initialPageCompleted: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNextPromo = () => {
    const getRestaurant = async () => {
      console.log('PROMO ', promo);
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const body = {
        method: 'get',
        resource: 'restaurant',
        query: {
          'selfSignup.code': promo,
        },
        payload: {
          name: 1,
          alias: 1,
          googleListing: 1,
          selfSignup: 1,
          disabled: 1,
          'menus.id': 1,
        },
      };
      console.log('HERE 1');
      try {
        const res = await axios.post(
          `${baseURL}/smart-restaurant/api`,
          body,
          config
        );

        console.log('RESPONSE ', res);
        dispatch(updateState({ showRestaurantSearch: false }));
        dispatch(updateState({ Signup_type: 'promo' }));
        dispatch(updateState({ Restaurant_alias: res.data[0].alias }));
        if (
          res.data[0].disabled.toString() === 'false' ||
          (res.data[0].selfSignup && res.data[0].selfSignup.acknowledgedAt)
        ) {
          console.log('DISABLED KEY ', res.data[0].disabled);
          dispatch(updateState({ alreadyWorkWithUs: true }));
        }
        dispatch(
          updateState({
            Restaurant_address: res.data[0].googleListing.address,
          })
        );
        console.log('HERE 2');
        if (res.data[0].menus) {
          dispatch(updateState({ menu_id: res.data[0].menus[0].id }));
        }
        dispatch(updateState({ Restaurant_found: res.data[0].name }));
        // eslint-disable-next-line no-param-reassign, no-underscore-dangle
        // eslint-disable-next-line no-param-reassign, no-underscore-dangle
        dispatch(updateState({ Restaurant_id: res.data[0]._id }));

        updateAnalytics(
          {
            source: 'Promo URL',
          },
          // eslint-disable-next-line no-underscore-dangle
          res.data[0]._id
        );
        dispatch(
          updateState({ Google_phone: res.data[0].googleListing.phone })
        );
        dispatch(updateState({ initialPageCompleted: true }));
        dispatch(updateState({ step: 1 }));
      } catch (e) {
        dispatch(
          updateState({
            alreadyWorkWithUs: false,
          })
        );
        dispatch(updateState({ step: 1 }));
        dispatch(updateState({ Signup_type: 'Non_promo' }));
        console.log('request failed', e);
        dispatch(updateState({ initialPageCompleted: true }));
      }
    };
    if (promo) {
      getRestaurant();
    }
  };

  return (
    <ViewPortContainer>
      <TopLayer>
        <LogoAndStepper showStepper={false} />
      </TopLayer>
      <MiddleLayer>
        <BoxContentContainer>
          <Typography variant="h4">
            {translate('Welcome to qMenu.')}{' '}
            {language === 'Chinese' ? (
              <> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</>
            ) : null}{' '}
          </Typography>
          <br />
          <Typography variant="h6">
            {translate('Restaurant sign up in 3 minutes or less')}
          </Typography>
          <br />

          <TextField
            color="primary"
            variant="outlined"
            margin="normal"
            value={promo}
            onChange={(e) => setPromo(e.target.value)}
            required
            fullWidth
            id="promo"
            label={translate('Enter promo here')}
            name="promo"
            autoComplete="email"
            autoFocus
          />
          <br />
          <TransitionButtons executeLogic={handleNextPromo} />
        </BoxContentContainer>{' '}
      </MiddleLayer>

      <BottomLayer>
        <DesignAndLanguages showLanguages={true} />
      </BottomLayer>
    </ViewPortContainer>
  );
}
